import React from "react";

import Button from "@mui/material/Button";
import { Link } from "react-router-dom";

import ShortAnswerSubmitButton from './SubmitButtons/ShortAnswerSubmitButton';
import MultipleChoiceSubmitButton from './SubmitButtons/MultipleChoiceSubmitButton';
import TrueFalseSubmitButton from './SubmitButtons/TrueFalseSubmitButton';
import DefaultSubmitButton from './SubmitButtons/DefaultSubmitButton';

interface IFlipSubmitButtonProps {
    editSubject: (
        event: React.MouseEvent<HTMLAnchorElement, MouseEvent>
    ) => void;
    getAnswer: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
    getQuestionEasy: (
        event: React.MouseEvent<HTMLAnchorElement, MouseEvent>
    ) => void;
    getQuestionRight: (
        event: React.MouseEvent<HTMLAnchorElement, MouseEvent>
    ) => void;
    getQuestionWrong: (
        event: React.MouseEvent<HTMLAnchorElement, MouseEvent>
    ) => void;
    getQuestion: (
        event: React.MouseEvent<HTMLAnchorElement, MouseEvent>
    ) => void;
    questionType: string;
    showAnswer: boolean;
    showError: boolean;
    subject_user: string;
    subject_slug: string;
    object_id: string;
}

export default function FlipSubmitButton({
    getAnswer,
    getQuestionEasy,
    getQuestionRight,
    getQuestionWrong,
    getQuestion,
    questionType,
    showAnswer,
    showError,
    editSubject,
    subject_slug,
    subject_user,
    object_id
}: IFlipSubmitButtonProps) {
    let buttons = <></>;

    // var submitButton: TypeOfSubmitButton;
    // switch (questionType) {
    //     case "short-answer":
    //         submitButton = ShortAnswerSubmitButton(getQuestionWrong, getQuestionRight, getQuestionEasy);
    //     case "multiple-choice":
    //         submitButton = MultipleChoiceSubmitButton();
    //     case "true-false":
    //         submitButton = TrueFalseSubmitButton();
    //     case "default":
    //         submitButton = DefaultSubmitButton();
                        
    //     }

    // if (showAnswer) {
    //     buttons = submitButton.getButton();
    // }

    if (showAnswer) {
        switch (questionType) {
            case "short-answer":
                buttons = (
                    <>
                        <Button
                            variant="contained"
                            color="secondary"
                            onClick={getQuestionWrong}
                            href="#"
                        >
                            Wrong :-(
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={getQuestionRight}
                            href="#"
                        >
                            I got it Right!
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={getQuestionEasy}
                            href="#"
                        >
                            It was easy!
                        </Button>
                    </>
                );
                break;
            default:
                buttons = (
                    <Button onClick={getQuestion} href="#">
                        Next Question
                    </Button>
                );
        }
    } else if (showError) {
        buttons = (
            <>
                <Button onClick={getQuestion} href="#">
                    Next Question
                </Button>
                <Button onClick={editSubject} href="#">
                    Edit Subject
                </Button>
            </>
        );
    } else {
        switch (questionType) {
            case "short-answer":
                buttons = (
                    <Button
                        variant="contained"
                        onClick={getAnswer}
                        href="#"
                    >
                        Flip
                    </Button>
                );
                break;
            case "multiple-choice":
                buttons = (
                    <Button
                        color="primary"
                        variant="contained"
                        onClick={getAnswer}
                        href="#"
                    >
                        Submit Answer
                    </Button>
                );
                break;
            case "true-false":
                buttons = (
                    <Button
                        color="primary"
                        variant="contained"
                        onClick={getAnswer}
                        href="#"
                    >
                        Submit Answer
                    </Button>
                );
                break;
            default:
                buttons = (
                    <Button
                        color="primary"
                        variant="contained"
                        onClick={getAnswer}
                        href="#"
                    >
                        Submit Answer
                    </Button>
                );
                break;
        }
    }

    return (
        <div className="row foreground-bottom">
            <div className="col-12">
                {showAnswer ? (
                    <Button
                        variant="contained"
                        component={Link}
                        to={`/subject/${subject_user}/${subject_slug}/o/${object_id}?from_quizzer=true`}
                    >
                        Review Note
                    </Button>
                ) : (
                    <></>
                )}
                {buttons}
            </div>
        </div>
    );
}
